import React from 'react';
import { Capsule, CapsuleProps } from './Capsule';
import TickMarkIcon from '~/assets/icons/tick-mark.svg';
import LanguageIcon from '~/assets/icons/language.svg';
import PlaybackSpeedIcon from '~/assets/icons/playback-speed.svg';

export const TickMarkCapsule = (props: CapsuleProps) => (
  <Capsule {...props} aria-hidden="true">
    <TickMarkIcon aria-hidden="true" focusable="false" />
  </Capsule>
);

export const LanguageCapsule = (props: CapsuleProps) => (
  <Capsule {...props} aria-hidden="true">
    <LanguageIcon aria-hidden="true" focusable="false" />
  </Capsule>
);

export const PlaybackSpeedCapsule = (props: CapsuleProps) => (
  <Capsule {...props} aria-hidden="true">
    <PlaybackSpeedIcon aria-hidden="true" focusable="false" />
  </Capsule>
);
